var strictEmailRegex = window.strictEmailRegex;
var rfc2822EmailRegex = window.rfc2822EmailRegex;
var pluralRules = window.pluralRules;
var NumberWords = window.NumberWords;
var NumberWords, pluralRules, rfc2822EmailRegex, strictEmailRegex;
window.$h || (window.$h = {});
window.$h.commaizeInt = function (x, usedLocale) {
  var commaized, oldLocale, parts;
  if (x == null) {
    return x;
  }
  if (I18n) {
    if (!usedLocale) {
      return I18n.toNumber(x, {
        precision: 0
      });
    } else {
      oldLocale = I18n.currentLocale();
      I18n.locale = usedLocale;
      commaized = I18n.toNumber(x, {
        precision: 0
      });
      I18n.locale = oldLocale;
      return commaized;
    }
  } else {
    parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
};
window.$h.numberAndNoun = function (number, noun, usedLocale) {
  return $h.commaizeInt(number, usedLocale) + " " + $h.pluralize(number, noun);
};
window.$h.aOrNumberAndNoun = function (number, noun, usedLocale) {
  var pluralizedNoun;
  pluralizedNoun = $h.pluralize(number, noun);
  if (number === 1) {
    return $h.aOrAn(noun) + " " + pluralizedNoun;
  } else {
    return $h.commaizeInt(number, usedLocale) + " " + pluralizedNoun;
  }
};
pluralRules = [[/(s)yllabi$/i, "$1yllabi"], [/(s)yllabus$/i, "$1yllabi"], [/(z)ombies$/i, "$1ombies"], [/(z)ombie$/i, "$1ombies"], [/(m)oves$/i, "$1oves"], [/(m)ove$/i, "$1oves"], [/(s)exes$/i, "$1exes"], [/(s)ex$/i, "$1exes"], [/(c)hildren$/i, "$1hildren"], [/(c)hild$/i, "$1hildren"], [/(m)en$/i, "$1en"], [/(m)an$/i, "$1en"], [/(p)eople$/i, "$1eople"], [/(p)erson$/i, "$1eople"], [/(quiz)$/i, "$1zes"], [/^(oxen)$/i, "$1"], [/^(ox)$/i, "$1en"], [/^(m|l)ice$/i, "$1ice"], [/^(m|l)ouse$/i, "$1ice"], [/(matr|vert|ind)(?:ix|ex)$/i, "$1ices"], [/(x|ch|ss|sh)$/i, "$1es"], [/([^aeiouy]|qu)y$/i, "$1ies"], [/(hive)$/i, "$1s"], [/(?:([^f])fe|([lr])f)$/i, "$1\\2ves"], [/sis$/i, "ses"], [/([ti])a$/i, "$1a"], [/([ti])um$/i, "$1a"], [/(buffal|tomat)o$/i, "$1oes"], [/(bu)s$/i, "$1ses"], [/(alias|status)$/i, "$1es"], [/(octop|vir)i$/i, "$1i"], [/(octop|vir)us$/i, "$1i"], [/^(ax|test)is$/i, "$1es"], [/s$/i, "s"], [/$/, "s"]];
window.$h.pluralize = function (number, noun) {
  var pluralNounForm, singular_plural_mapping;
  pluralNounForm = function (text) {
    var i, j, ref, ref1, regexp, repl;
    for (i = j = 0, ref = pluralRules.length; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      ref1 = pluralRules[i], regexp = ref1[0], repl = ref1[1];
      if (text.match(regexp)) {
        return text.replace(regexp, repl);
      }
    }
    return text;
  };
  if (_.isString(noun)) {
    singular_plural_mapping = {
      singular: noun,
      plural: pluralNounForm(noun)
    };
  } else {
    singular_plural_mapping = noun;
  }
  if (number === 1) {
    return singular_plural_mapping.singular;
  } else {
    return singular_plural_mapping.plural;
  }
};
window.$h.aOrAn = function (noun) {
  if (noun && 'aeiouAEIOU'.indexOf(noun[0]) >= 0) {
    return 'an';
  } else {
    return 'a';
  }
};
window.$h.humanFileSize = function (bytes, decimalPlaces) {
  var threshold, unitIndex, units;
  if (decimalPlaces == null) {
    decimalPlaces = 0;
  }
  threshold = 1024;
  units = ["B", "KB", "MB", "GB"];
  unitIndex = 0;
  while (bytes >= threshold) {
    bytes /= threshold;
    unitIndex++;
  }
  return bytes.toFixed(decimalPlaces) + " " + units[unitIndex];
};
rfc2822EmailRegex = /^[a-z0-9$!#%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9$!#%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
strictEmailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i;
window.$h.validEmail = function (text, options) {
  var regex;
  if (options == null) {
    options = {};
  }
  if (options.strict) {
    regex = strictEmailRegex;
  } else {
    regex = rfc2822EmailRegex;
  }
  return !!(text && regex.test(text));
};
window.$h.linkify = function (text, options) {
  var callback;
  if (options == null) {
    options = {};
  }
  if (options.target === "_blank") {
    callback = function (text, href) {
      if (href) {
        return "<a href=\"" + href + "\" title=\"" + href + "\" target=\"_blank\">" + text + "</a>";
      } else {
        return text;
      }
    };
    return window.linkify(text, {
      callback: callback
    });
  } else {
    return window.linkify(text);
  }
};
window.$h.timeAgoInWords = function (time, options) {
  if (options == null) {
    options = {};
  }
  return window.$h.distanceOfTimeInWords(new Date(), time, options);
};
window.$h.distanceOfTimeInWords = function (fromTime, toTime, options) {
  var days, distanceInMinutes, distanceInSeconds, fromSeconds, hours, minutesInDay, minutesInHour, minutesInMonth, minutesInYear, months, shortened, toSeconds, unit, years;
  if (options == null) {
    options = {};
  }
  minutesInHour = 60;
  minutesInDay = minutesInHour * 24;
  minutesInMonth = minutesInDay * 30;
  minutesInYear = minutesInDay * 365;
  shortened = options.shortened;
  fromSeconds = fromTime.getTime();
  toSeconds = toTime.getTime();
  distanceInSeconds = Math.round(Math.abs(fromSeconds - toSeconds) / 1000);
  distanceInMinutes = Math.round(distanceInSeconds / 60);
  if (distanceInSeconds < 30) {
    if (shortened) {
      return "< 1 min";
    } else {
      return "less than a minute";
    }
  } else if (distanceInSeconds < 60) {
    if (shortened) {
      return "1 min";
    } else {
      return "1 minute";
    }
  } else if (distanceInMinutes < 45) {
    unit = shortened ? "min" : "minute";
    return $h.numberAndNoun(distanceInMinutes, unit);
  } else if (distanceInMinutes < minutesInDay) {
    hours = Math.round(distanceInMinutes / minutesInHour);
    unit = shortened ? "hr" : "hour";
    return $h.numberAndNoun(hours, unit);
  } else if (distanceInMinutes < minutesInMonth) {
    days = Math.round(distanceInMinutes / minutesInDay);
    return $h.numberAndNoun(days, "day");
  } else if (distanceInMinutes < minutesInYear) {
    months = Math.round(distanceInMinutes / minutesInMonth);
    unit = shortened ? "mo" : "month";
    return $h.numberAndNoun(months, unit);
  } else {
    years = Math.round(distanceInMinutes / minutesInYear);
    unit = shortened ? "yr" : "year";
    return $h.numberAndNoun(years, unit);
  }
};
window.$h.capitalize = function (text) {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
window.$h.titleize = function (text) {
  return _(text.split(/\s+/)).map(function (word) {
    return window.$h.capitalize(word);
  }).join(" ");
};
NumberWords = ['none', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];
window.$h.numberWord = function (count) {
  return NumberWords[count] || count.toString();
};
window.$h.dateInWords = function (fromTime, toTime) {
  var days, distanceInMinutes, distanceInSeconds, fromSeconds, hours, minutesInDay, minutesInHour, minutesInMonth, minutesInYear, toSeconds, unit;
  if (toTime == null) {
    toTime = new Date();
  }
  minutesInHour = 60;
  minutesInDay = minutesInHour * 24;
  minutesInMonth = minutesInDay * 30;
  minutesInYear = minutesInDay * 365;
  fromSeconds = fromTime.getTime();
  toSeconds = toTime.getTime();
  distanceInSeconds = Math.round(Math.abs(fromSeconds - toSeconds) / 1000);
  distanceInMinutes = Math.round(distanceInSeconds / 60);
  if (distanceInSeconds < 30) {
    return "Just now";
  } else if (distanceInSeconds < 60) {
    return "1 minute";
  } else if (distanceInMinutes < 45) {
    unit = "minute";
    return $h.numberAndNoun(distanceInMinutes, unit);
  } else if (distanceInMinutes < minutesInDay) {
    hours = Math.round(distanceInMinutes / minutesInHour);
    unit = "hour";
    return $h.numberAndNoun(hours, unit);
  } else if (distanceInMinutes < minutesInMonth) {
    days = Math.round(distanceInMinutes / minutesInDay);
    return $h.numberAndNoun(days, "day");
  } else if (distanceInMinutes < minutesInYear) {
    return moment.monthsShort()[fromTime.getMonth()] + " " + fromTime.getDate();
  } else {
    return moment.monthsShort()[fromTime.getMonth()] + " " + fromTime.getFullYear();
  }
};
window.NumberWords = NumberWords;
window.pluralRules = pluralRules;
window.rfc2822EmailRegex = rfc2822EmailRegex;
window.strictEmailRegex = strictEmailRegex;